// 兼容线上，后续逻辑应该迁移到detail模块中
import eventManager from '@alife/scc-event-manager/event-manager';
import safeLog from '@alife/bc-safe-log';
import { DETAIL_NAVS } from './config';
import { logDeprecate } from './log';

function getNavConfig(dom) {
  const id = dom.getAttribute('data-section');
  if (DETAIL_NAVS[id]) {
    logDeprecate('mappedNav');
    return { id, dom, textKey: DETAIL_NAVS[id], text: '' };
  }

  // 正常富文本标题在 #ali-title- 节点内
  const elTitle = dom.querySelector(`#ali-title-${id}`);
  if (elTitle) {
    return { id, dom, text: elTitle.textContent.trim() };
  }
  // 老的智能编辑和神笔 section 内只有标题文案
  if (!dom.children.length) {
    const text = dom.textContent.trim();
    if (text) {
      return { id, dom, text };
    }
  }

  logDeprecate('noTitleDom');
  return { id, dom, text: dom.getAttribute('data-section-title') };
}

function renderDetailNav() {
  const anchors = [];
  const elAnchors = document.querySelectorAll(
    '#J-rich-text-description [data-section]',
  );
  for (let i = 0; i < elAnchors.length; i++) {
    anchors.push(getNavConfig(elAnchors[i]));
  }

  const id = 'productDetail';
  eventManager.trigger('setAnchors', { id, anchors }) &&
    safeLog(
      '/sc.details.error',
      'OTHER',
      `scene=tabNav_${id}&msg=setAnchorErr`,
    );
}

export default renderDetailNav;
